<div class="appointment-page">
  <!-- Top info banner (full width) -->
  <div class="banner">
    <div class="banner-inner">
      <app-info-circle stroke="#F79009" width="1rem" height="1rem"></app-info-circle>
      <span class="text-sm-medium text-warning-900">
        Svaki zakazani termin odnosi se na prikaz jednog projekta. Ako imate više projekata, potrebno je zakazati poseban termin za svaki.
      </span>
    </div>
  </div>

  <!-- Main (full width) -->
  <div class="main">
    <div class="main-inner">
      <div class="form-content">
        <!-- Title row -->
        <div class="title-row">
          <div class="flex flex-column gap-1">
            <h2 class="display-xs-semibold text-gray-900 m-0">Zakazivanje termina</h2>
            <span class="text-md-regular text-gray-600">Unesite sve potrebne informacije za termin.</span>
          </div>
          <button type="button" class="close-btn" (click)="cancel()" aria-label="Zatvori">
            <app-x-close stroke="#181D27" width="12px" height="12px"></app-x-close>
          </button>
        </div>

        <!-- Detalji termina -->
        <div class="section-heading">
          <div class="text-md-semibold text-gray-900">Detalji termina</div>
          <div class="text-sm-regular text-gray-600">Izaberite trajanje, datum i vreme termina.</div>
        </div>

        <form [formGroup]="form" class="flex flex-column gap-4">
          <div class="form-field">
            <label class="text-sm-medium text-gray-700" for="duration">
              Trajanje termina <span class="text-red-600">*</span>
            </label>
            <div class="dropdown-with-helper">
              <app-dropdown
                formCtrlId="duration"
                optionLabel="label"
                optionValue="value"
                ctrlPlaceholder="Izaberite trajanje"
                [hasIcon]="true"
                [formCtrl]="durationCtrl"
                [options]="durationOptions()"
              >
                <app-hourglas-03 dropdownIcon stroke="#ADB0B8" width="20px" height="20px"></app-hourglas-03>
              </app-dropdown>
              <div class="text-sm-regular text-gray-600">Dostupno: {{ packageHours() ?? 0 }} sati.</div>
            </div>
          </div>

          @if (!noSlots()) {
            <div class="date-time-row">
              <div class="form-field date-col">
                <label class="text-sm-medium text-gray-700">
                  Datum <span class="text-red-600">*</span>
                </label>
                <app-calendar
                  [formCtrl]="dateCtrl"
                  [inline]="true"
                  [ctrlShowTime]="false"
                  [hideErrors]="true"
                  [minDateCtrl]="minDate()"
                  [maxDateCtrl]="maxDate()"
                  [unavailableDays]="disabledDates()"
                ></app-calendar>
              </div>

              <div class="form-field time-col">
                <label class="text-sm-medium text-gray-700">
                  Vreme <span class="text-red-600">*</span>
                </label>
                @if (!dateCtrl.value) {
                  <div class="time-empty text-sm-regular text-gray-500">Izaberite datum</div>
                } @else {
                  <div class="time-slots">
                    @for (interval of availableIntervals(); track interval.from) {
                      <button
                        type="button"
                        class="time-slot"
                        [class.selected]="isIntervalSelected(interval)"
                        (click)="selectInterval(interval)"
                      >
                        {{ formatTime(interval.from) }} - {{ formatTime(interval.to) }}
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </form>

        @if (noSlots()) {
          <div class="no-slots text-sm-regular text-gray-500">
            Nema dostupnih termina
          </div>
        } @else {

        <hr class="section-divider" />

        <!-- Plan projekta -->
        <div class="section-heading">
          <div class="text-md-semibold text-gray-900">Plan projekta</div>
        </div>

        <div class="plan-card">
          <div class="plan-card-image">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="floorplan-mask-0" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="80"
                    height="80">
                <path d="M0 0H80V80H0V0Z" fill="white" />
              </mask>
              <g mask="url(#floorplan-mask-0)">
                <path d="M58.5936 77.6562H2.34375V2.34375H77.6562V77.6562H70.4686" stroke="#181D27" stroke-width="3"
                      stroke-miterlimit="10" />
                <path d="M46.6953 3.19078V33.8398" stroke="#181D27" stroke-width="3" stroke-miterlimit="10" />
              </g>
              <path d="M64.8202 33.8398H23.5664" stroke="#181D27" stroke-width="3" stroke-miterlimit="10" />
              <mask id="floorplan-mask-1" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="80"
                    height="80">
                <path d="M0 0H80V80H0V0Z" fill="white" />
              </mask>
              <g mask="url(#floorplan-mask-1)">
                <path d="M2.34375 33.8398H11.5919" stroke="#181D27" stroke-width="3" stroke-miterlimit="10" />
                <path d="M2.34375 47.375H11.5919" stroke="#181D27" stroke-width="3" stroke-miterlimit="10" />
                <path d="M32.9414 77.7461V47.3744" stroke="#181D27" stroke-width="3" stroke-miterlimit="10" />
                <path d="M51.6328 65.7812V47.375H77.6575" stroke="#181D27" stroke-width="3" stroke-miterlimit="10" />
              </g>
              <path d="M23.5664 47.375H39.0647" stroke="#181D27" stroke-width="3" stroke-miterlimit="10" />
            </svg>
          </div>
          <div class="plan-card-body">
            <div class="plan-card-text">
              <div class="text-sm-semibold text-gray-900">Uputstvo za pripremu fajla</div>
              <div class="text-sm-regular text-gray-700">
                Za ispravan prikaz tokom termina, potrebno je da fajl bude pripremljen prema definisanim pravilima.
              </div>
            </div>
            <a class="plan-card-link" href="javascript:void(0)">
              <span class="text-sm-semibold">Pogledaj uputstvo</span>
              <app-link-external-02 stroke="#2970FF" width="0.875rem" height="0.875rem"></app-link-external-02>
            </a>
          </div>
        </div>

        <div class="plan-note">
          <app-info-circle stroke="#2970FF" width="1rem" height="1rem"></app-info-circle>
          <span class="text-sm-regular text-gray-600">
            Dostavljanje fajlova nije obavezno prilikom zakazivanja, ali je potrebno dostaviti ih najkasnije 24 sata pre termina.
          </span>
        </div>

        <!-- Fajlovi -->
        <div class="section-heading">
          <div class="text-md-semibold text-gray-900">Fajlovi</div>
          <div class="text-sm-regular text-gray-600">Plan projekta se može dostaviti u jednom, ili u oba formata.</div>
        </div>

        <!-- PDF -->
        <div class="form-field">
          <label class="text-sm-medium text-gray-700">PDF</label>
          @if (pdfFile(); as f) {
            <div class="file-row">
              <div class="file-row-icon">
                <app-pdf width="2rem" height="2rem"></app-pdf>
              </div>
              <div class="file-row-info">
                <span class="text-sm-medium text-gray-900">{{ f.name }}</span>
                <div class="flex align-items-center gap-2">
                  <span class="text-xs-regular text-gray-500">{{ formatFileSize(f.size) }}</span>
                  <span class="file-row-status">
                    <app-check-circle stroke="#17B26A" width="0.875rem" height="0.875rem"></app-check-circle>
                    <span class="text-xs-medium text-success-700">100%</span>
                  </span>
                </div>
              </div>
              <button type="button" class="file-row-remove" (click)="removeFile('pdf', $event)" aria-label="Ukloni">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          } @else {
            <label class="upload-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event, 'pdf')">
              <input type="file" accept=".pdf,application/pdf" hidden (change)="onFileSelected($event, 'pdf')" />
              <div class="upload-zone-icon">
                <app-attachment-02 stroke="#414651" width="1.125rem" height="1.125rem"></app-attachment-02>
              </div>
              <div class="text-sm-regular text-gray-600">
                <span class="upload-zone-link">Kliknite za dodavanje</span> ili prevucite fajl
              </div>
            </label>
          }
        </div>

        <!-- AutoCAD -->
        <div class="form-field">
          <label class="text-sm-medium text-gray-700">AutoCAD</label>
          @if (autoCadFile(); as f) {
            <div class="file-row">
              <div class="file-row-icon">
                <app-dwg width="2rem" height="2rem"></app-dwg>
              </div>
              <div class="file-row-info">
                <span class="text-sm-medium text-gray-900">{{ f.name }}</span>
                <div class="flex align-items-center gap-2">
                  <span class="text-xs-regular text-gray-500">{{ formatFileSize(f.size) }}</span>
                  <span class="file-row-status">
                    <app-check-circle stroke="#17B26A" width="0.875rem" height="0.875rem"></app-check-circle>
                    <span class="text-xs-medium text-success-700">100%</span>
                  </span>
                </div>
              </div>
              <button type="button" class="file-row-remove" (click)="removeFile('autoCad', $event)" aria-label="Ukloni">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          } @else {
            <label class="upload-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event, 'autoCad')">
              <input type="file" accept=".dwg,.dxf" hidden (change)="onFileSelected($event, 'autoCad')" />
              <div class="upload-zone-icon">
                <app-attachment-02 stroke="#414651" width="1.125rem" height="1.125rem"></app-attachment-02>
              </div>
              <div class="text-sm-regular text-gray-600">
                <span class="upload-zone-link">Kliknite za dodavanje</span> ili prevucite fajl
              </div>
            </label>
          }
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Footer (full width) -->
  <footer class="footer">
    <div class="footer-inner">
      <app-button
        [btnSize]="ButtonSize.MD"
        [btnSeverity]="ButtonSeverity.SECONDARY"
        (btnClicked)="cancel()"
      >
        <div class="text-sm-semibold text-gray-900">Otkaži</div>
      </app-button>
      <app-button
        [btnSize]="ButtonSize.MD"
        [btnSeverity]="ButtonSeverity.PRIMARY"
        [isBtnDisabled]="form.invalid"
        (btnClicked)="submit()"
      >
        <div class="text-sm-semibold text-white">Zakaži termin</div>
      </app-button>
    </div>
  </footer>
</div>

<p-dialog [(visible)]="showConfirmDialog"
          [modal]="true"
          [closable]="false"
          [style]="{ width: '25rem' }"
>
  <div class="flex flex-column">
    <div class="text-lg-semibold text-gray-900">
      Termin je uspešno zakazan
    </div>
    <div class="mt-1 text-sm-regular text-gray-600">Vaš termin je dodat u raspored i možete ga videti u listi
      predstojećih termina.
    </div>
  </div>
  <ng-template #header>
    <div class="flex align-items-center justify-content-between w-full">
      <div class="flex justify-content-center align-items-center success-dialog-icon">
        <app-check-circle stroke="#414651" width="20px" height="20px"></app-check-circle>
      </div>
      <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer"
                   (click)="showConfirmDialog.set(false);"></app-x-close>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flex justify-content-end align-items-center w-full">
      @if (user.isCompany()) {
        <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="bookAnother()">
          <div class="text-sm-semibold text-gray-900">Zakazi jos jedan termin</div>
        </app-button>
        <app-button class="ml-2-5" [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="companyLocation.routeToAppointments()">
          <div class="text-sm-semibold text-white">U redu</div>
        </app-button>
      } @else {
        <app-button class="ml-2-5" [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="individualLocation.routeToAppointments()">
          <div class="text-sm-semibold text-white">U redu</div>
        </app-button>
      }
    </div>
  </ng-template>
</p-dialog>
